export function TimeForwardIcon(
  props: React.SVGProps<SVGSVGElement> & { color: string },
) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25_599)">
        <path
          d="M23 11C22.7348 11 22.4805 11.1054 22.2929 11.2929C22.1054 11.4804 22 11.7348 22 12C22.0082 14.3253 21.2084 16.5812 19.7376 18.3822C18.2667 20.1831 16.216 21.4173 13.9359 21.8738C11.6559 22.3303 9.28807 21.9807 7.23721 20.8849C5.18636 19.789 3.57977 18.0148 2.69206 15.8657C1.80435 13.7165 1.69064 11.3257 2.37035 9.10201C3.05006 6.87828 4.48099 4.95966 6.41858 3.67407C8.35616 2.38849 10.6801 1.81575 12.9932 2.05377C15.3062 2.29179 17.4649 3.32578 19.1 4.979C19.0671 4.98797 19.0337 4.99498 19 5H16C15.7348 5 15.4805 5.10536 15.2929 5.29289C15.1054 5.48043 15 5.73478 15 6C15 6.26522 15.1054 6.51957 15.2929 6.70711C15.4805 6.89464 15.7348 7 16 7H19C19.7957 7 20.5587 6.68393 21.1213 6.12132C21.684 5.55871 22 4.79565 22 4V1C22 0.734784 21.8947 0.48043 21.7071 0.292893C21.5196 0.105357 21.2652 0 21 0C20.7348 0 20.4805 0.105357 20.2929 0.292893C20.1054 0.48043 20 0.734784 20 1V3.065C17.9526 1.23453 15.3389 0.162166 12.5959 0.0271026C9.85281 -0.107961 7.14648 0.702457 4.92911 2.32293C2.71174 3.94341 1.11766 6.27578 0.413253 8.9303C-0.291156 11.5848 -0.0632278 14.4007 1.05895 16.9074C2.18113 19.414 4.12958 21.4596 6.57871 22.7024C9.02784 23.9451 11.8293 24.3097 14.5149 23.7353C17.2006 23.1608 19.6077 21.682 21.3341 19.5461C23.0605 17.4101 24.0015 14.7464 24 12C24 11.7348 23.8947 11.4804 23.7071 11.2929C23.5196 11.1054 23.2652 11 23 11Z"
          fill={props.color}
        />
        <path
          d="M12.0002 6C11.7349 6 11.4806 6.10536 11.293 6.29289C11.1055 6.48043 11.0002 6.73478 11.0002 7V12C11.0002 12.2652 11.1056 12.5195 11.2932 12.707L14.2932 15.707C14.4818 15.8892 14.7344 15.99 14.9966 15.9877C15.2587 15.9854 15.5096 15.8802 15.695 15.6948C15.8804 15.5094 15.9855 15.2586 15.9878 14.9964C15.9901 14.7342 15.8893 14.4816 15.7072 14.293L13.0002 11.586V7C13.0002 6.73478 12.8948 6.48043 12.7073 6.29289C12.5197 6.10536 12.2654 6 12.0002 6V6Z"
          fill={props.color}
        />
      </g>
      <defs>
        <clipPath id="clip0_25_599">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
